<template>
    <b-col class="OTPipelineAdminrule">
        <otif-table :rows="rows" :columns="columns" title="Rules" :actions="actions" :globalActions="globalActions"/>
        <otif-modal v-model="addRuleModal" title="Create New Rule">
            <b-form @submit="saveNewRule" id="addRuleForm">
                <otif-textInput
                    name="name"
                    v-model="newRule.ruleName"
                    label="Rule Name"
                    :validation="newRuleValidation"
                    invalidMessage="Name can only contain alphanumeric characters"
                    required/>

            </b-form>
            <template slot="footer">
                <otif-button class="OTSecondary" @click.native="addRuleModal = false">Cancel</otif-button>
                <otif-button class="OTPrimary" @click.native="saveNewRule">Save</otif-button>
            </template>
        </otif-modal>
    </b-col>

</template>

<script>

import axios from 'axios';
import ConditionsColumn from './table/ConditionsColumn.vue';
import errorMsgs from '../../../messages/errors.icu';

export default {

    watch: {
        addRuleModal(newVal) {
            if (newVal === false) {
                this.newRule.ruleName = '';
            }
        }
    },

    data() {
        return {
            addRuleModal: false,
            newRuleValidation: {
                $error: false,
                $dirty: false,
                message: ''
            },
            newRule: {
                ruleName: '',
                ruleOperator: 'OR',
                conditions: {
                    value: []
                }
            },
            rows: [],
            data: null,
            globalActions: [{
                name: 'add',
                label: 'Add Rule',
                callback: () => {
                    this.add_rule();
                }
            }],
            columns: [{
                name: 'rule',
                label: 'Rule Name'
            },{
                name: 'conditions',
                label: 'Conditions',
                displayComponent: ConditionsColumn
            }],
            actions: [{
                name: 'edit',
                label: 'Edit',
                callback: this.editRule
            },{
                name: 'delete',
                label: 'Delete',
                callback: this.deleteRule
            }]
        }
    },

    methods: {
        async saveNewRule(e) {
            this.$snotify.info('Creating rule ...', {timeout: 0});
            e.preventDefault();

            try {
                const res = await axios.post('/mtm-gateway-api/v1/services/pipeline/activation-rules', this.newRule);
                this.$snotify.clear();
                this.$snotify.success('Rule saved');
                this.addRuleModal = false;
                this.$router.push({
                    name: 'pipeline-activation-rules-edit',
                    params: {
                        ruleId: res.data.ruleId
                    }
                });
            } catch (e) {
                this.$snotify.clear();
                if (e.response) {
                    if (e.response.status === 400) {
                        this.newRuleValidation.$error = true;
                        this.newRuleValidation.$dirty = true;
                    }
                } else {
                    this.$snotify.error('There was an error saving the rule');
                }
            }
        },

        add_rule() {
            this.addRuleModal = true;
        },

        editRule(rowNumber, rows) {
            this.$router.push({
                name: 'pipeline-activation-rules-edit',
                params: {
                    ruleId: rows[rowNumber][2]
                }
            });
        },

        async deleteRule(rowNumber, rows) {
            this.$snotify.info('Deleting rule ...', { timeout: 0 });
            try {
                await axios.delete('/mtm-gateway-api/v1/services/pipeline/activation-rules/' + this.data[rowNumber].ruleId);
                this.rows.splice(rowNumber, 1);
                this.$snotify.clear();
                this.$snotify.success('Rule deleted');
            } catch (e) {
                this.$snotify.clear();
                if (e.response && e.response.status === 409) {
                    this.$snotify.error('The rule is currently in use by one or more components');
                } else {
                    this.$snotify.error('An error occurred when deleting the rule');
                }
            }
        },

        async load() {
            const res = await axios.get('/mtm-gateway-api/v1/services/pipeline/activation-rules');

            res.data.activationRules.forEach((rule) => {
                this.rows.push([rule.ruleName, rule.conditions, rule.ruleId]);
            });

            this.data = res.data.activationRules;
        }
    },

    created() {
        this.load();
    }

}


</script>